// Browser RUM (Grafana Faro). VITE_FARO_COLLECTOR_URL is a build-time constant,
// so when it's unset this whole branch is dead-code-eliminated by Vite and the
// Faro bundle is never shipped. When set, Faro loads as a lazy chunk.
if (import.meta.env.VITE_FARO_COLLECTOR_URL) {
  import("../lib/faro").then(({ initFaro }) => initFaro())
}

import "@hotwired/turbo-rails"
Turbo.start()

import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import "@tailwindplus/elements"

const application = Application.start()
application.debug = true
window.Stimulus = application
const controllers = import.meta.glob("../controllers/**/*_controller.js", {
  eager: true,
})
registerControllers(application, controllers)
